// extracted by mini-css-extract-plugin
module.exports = {"statcard":"styles_statcard__1YHPz","statcard_label":"styles_statcard_label__2voIA"};